module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門5_7_5.faef5c50.png";